import React, { useState, useEffect } from "react";
import HeaderNonSrp from "../header/headerNonSrp";
import Footer from "../footer/footer";
import PgBlock from "../common/pgBlock";
import Checkbox from "../common/input/checkbox";
import AlertTerms from "../common/login/alertTerms";
import { GetRequest } from "../common/helper";
import { apiUrl } from "../common/constants";
const pgDetails = { pg: 'razorpay' }
const Branch = (props) => {

    const [selPg, setSelPg] = useState('razorpay');
    const [tcFlag, setTcFlag] = useState(false);
    const [alertFlag, setAlertFlag] = useState(false);
    const [details, setDetails] = useState(false);
    const [loader, setLoader] = useState(false);
    const setTncFLag = (value) => {
        setTcFlag(value)
    }

    useEffect(() => {
        setLoader(true);
        let url = apiUrl.getBranchOrder +
            "?token=" +
            props.match.params.token;

        GetRequest(url)
            .then(res => {
                setLoader(false);
                if (res.Success) {
                    let data = res.data;
                    setDetails(data)
                }
            }).catch((err) => {
                console.log(err);
                setLoader(false);
            })
    }, [])

    const makePayment = () => {
        if (!tcFlag) {
            setAlertFlag(true);
        }
        if (tcFlag && details.email && details.amount > 0) {
            setLoader(true);
            document.getElementById('checkoutForm').submit();
        }
    }
    return (
        <>
            <HeaderNonSrp type={"branch"} />
            <section className="checkout-wrapper">
                <div className="right-div" style={{ width: '100%', height: '560px', background: '#fff', position: 'relative' }}>
                    <div>
                        <div
                            className="block"
                        >
                            <div className="hhh" style={{ padding: '0 16px' }}>
                                <div className="pay-opts" style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                                    <div className="pay-opts-item">

                                        <PgBlock
                                            value={pgDetails.pg}
                                            selected={selPg === pgDetails.pg ? true : false}
                                            onClick={() => setSelPg(pgDetails.pg)}
                                            name="PGType"
                                        />
                                    </div>
                                </div>
                                <div className="checkout_tandc" style={{ display: 'flex', marginTop: '20px', fontWeight: '500', fontSize: '14px', justifyContent: 'center' }}>
                                    <div>
                                        <Checkbox
                                            active={tcFlag}
                                            onClick={() => {
                                                setTcFlag(!tcFlag)
                                                !tcFlag && setAlertFlag(true);
                                            }
                                            }
                                        />
                                    </div>
                                    <div style={{ marginLeft: '16px' }}>I agree to KSRTC's <a style={{ color: '#004F9E', textDecoration: 'underline' }}>Terms & Conditions</a> {/* and <a style={{ color: '#004F9E', textDecoration: 'underline' }}>Privacy Policy</a> */}</div>
                                </div>
                                <div className="branch--button--wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div className="barnch--pay--button"
                                        onClick={makePayment}
                                        style={{
                                            width: '430px',
                                            padding: '15px 0px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            color: '#fff',
                                            background: '#ff7100',
                                            marginTop: '7px',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            marginTop: '20px',
                                            textTransform: 'uppercase'
                                        }}>PAY {window.currency_symbol} {details.amount} NOW through {pgDetails.pg} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {alertFlag &&
                    < AlertTerms
                        msg={"hello roushan"}
                        error={false}
                        className="login--alert"
                        setTncFLag={setTncFLag}
                        close={() => {
                            setAlertFlag(false)
                        }}
                    />

                }
                {loader ? (
                    <div className="show-load">
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </section>
            <form
                key="dssfd"
                id="checkoutForm"
                method="POST"
                action={window.url + "/branch/confirm"}
            >
                <input
                    type="hidden"
                    name="o"
                    id="o"
                    value={props.match.params.token}
                />
                <input type="hidden" name="owo" value="0" />
                <input type="hidden" name="method" id="method" value="1" />
                <input type="hidden" name="provider" id="provider" value="1" />

                <input
                    type="hidden"
                    name="countrycode"
                    id="countrycode"
                    value={"+91"}
                />
                <input
                    type="hidden"
                    name="mobile"
                    id="mobile"
                    value={details.mobile}
                />
                <input
                    type="hidden"
                    name="mobileNo"
                    id="mobileNo"
                    value={details.mobile}
                />
                <input
                    type="hidden"
                    name="email"
                    id="email"
                    value={details.email}
                />

                <input type="hidden" name="PGType" value={selPg} />
            </form>
        </>
    )
}

export default Branch;